import { Modal, Skeleton } from "antd";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useFetchPool } from "../../entities/api";
import AddEndEditPoolForm from "./AddEndEditPoolForm";

const AddAndEditPoolModal = ({ handleCloseModal, openModal, poolCode = null, handleSendRequest, okButtonLoading }) => {
  const { formatMessage } = useIntl();
  const [formRef, setFormRef] = useState(null);
  const { data: pool } = useFetchPool(poolCode);

  const handleSetFormRef = (form) => setFormRef(form);

  return (
    <Modal
      open={openModal}
      closable={true}
      destroyOnClose={true}
      onCancel={handleCloseModal}
      title={formatMessage({
        id: !poolCode ? "pool.add" : "pool.update",
      })}
      onOk={() => handleSendRequest(formRef)}
      okText={formatMessage({
        id: !poolCode ? "add" : "update",
      })}
      okButtonProps={{ loading: okButtonLoading }}
    >
      {!poolCode ? (
        <AddEndEditPoolForm handleSetFormRef={handleSetFormRef} />
      ) : pool ? (
        <AddEndEditPoolForm pool={pool} handleSetFormRef={handleSetFormRef} />
      ) : (
        <Skeleton />
      )}
    </Modal>
  );
};

export default AddAndEditPoolModal;
